'use client';

import { ReactNode } from 'react';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function GlassCard({ children, className = '', hover = false }: GlassCardProps) {
  return (
    <div
      className={`
        bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl
        shadow-xl shadow-black/10
        ${hover ? 'hover:bg-white/20 hover:border-white/30 transition-all duration-300' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
}